import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper d-flex flex-column justify-content-center align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "display-4" }, "Ooops ....", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "h1 mb-3" }, "It looks like the page you're looking for doesn't exist", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}